<template>
    <div class="home">
        <b-container fluid>
            <div class="d-flex justify-content-center mt-4 mr-4 ml-4">
                <img class="logo-oem" alt="OMEGA EUROPEAN MASTERS" src="../assets/img/logo-2019.svg">
            </div>
            <h1 class="text-center mt-4">{{ $t('access_card') }}</h1>
            <div class="d-flex flex-column align-items-center">
                <form class="oem-login-form" v-on:submit.prevent="onSubmit">
                    <div v-if="error" class="mt-4 text-center text-danger">{{ error }}</div>
                    <b-form-input v-model="login.username" :placeholder="$t('email')"
                                  class="mt-4 mb-2"></b-form-input>
                    <b-form-input v-model="login.password" :placeholder="$t('password')" class="mb-2"
                                  type="password"></b-form-input>
                    <b-button class="oem-login-button mt-3 mb-2" block type="submit">{{ $t('enter') }}</b-button>
                </form>
            </div>
        </b-container>
        <language-switcher></language-switcher>
    </div>
</template>

<script>
    import BContainer from "bootstrap-vue/src/components/layout/container";
    import axios from 'axios';
    import LanguageSwitcher from "../components/LanguageSwitcher";

    export default {
        name: 'partners',
        data: function () {
            return {
                error: null,
                login: {
                    username: null,
                    password: null
                }
            }
        },
        components: {
            LanguageSwitcher,
            BContainer
        },
        created() {
            if (this.$store.getters.isLogged)
                this.$router.push('./');
        },
        methods: {
            async onSubmit() {
                var headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };

                if (this.login.username === '' || this.login.password === '')
                    this.error = this.$t('fields_not_null');
                else {
                    var response = await axios.post('https://access-admin.omegaeuropeanmasters.com/en/scan/partners',
                        // var response = await axios.post('http://localhost:8000/en/scan/partners',
                        {
                            login: this.login.username,
                            password: this.login.password
                        },
                        {
                            headers: headers
                        });

                    if (response.data.status === 'Error')
                        this.error = this.$t('invalid_credentials');
                    else {
                        this.$store.dispatch('login', response.data);
                        this.$store.dispatch('setUsername', this.login.username);
                        this.$router.push('./');
                    }
                }
            },
        }
    }
</script>
<style lang="scss">
    .oem-login-form {
        max-width: 300px;
        width: 300px;
    }
</style>
